export type NavItem = {
  labelKey: string;
  to: string;
  mobileOnly?: boolean;
  desktopOnly?: boolean;
};

export const PRIMARY_NAV_ITEMS: NavItem[] = [
  { labelKey: "nav.dashboard", to: "/" },
  { labelKey: "nav.orders", to: "/orders" },
  { labelKey: "nav.products", to: "/products" },
  { labelKey: "nav.customers", to: "/customers" },
  { labelKey: "nav.billing", to: "/billing", desktopOnly: true },
  { labelKey: "nav.settings", to: "/settings", desktopOnly: true },
];

export const MOBILE_NAV_ITEMS: NavItem[] = PRIMARY_NAV_ITEMS.filter((item) => !item.desktopOnly);

// Desktop items with no slot in the mobile bottom bar; listed under "More".
export const MOBILE_MORE_ITEMS: NavItem[] = PRIMARY_NAV_ITEMS.filter((item) => item.desktopOnly);
